'use once'

module.exports = function once(fn, scope){

    var called
    var result

    return function(){
        if (called){
            return result
        }

        called = true

        return result = fn.apply(scope || this, arguments)
    }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/drag-helper/utils/once.js
// module id = 579
// module chunks = 0